import React from 'react';
import { Tabs } from 'antd';
import { TriptychLayout } from '../../components/layout/TriptychLayout';
// import RequirementsNatural from './components/RequirementsNatural';
// import RequirementsLegal from './components/RequirementsLegal';
import InitialLegalForm from './components/InitialLegalForm';
import NaturalForm from './components/NaturalForm';
import './styles.less';
import useMobileBreakpoint from '../../hooks/useMobileBreakpoint';

const InitPage = () => {
  const { TabPane } = Tabs;
  // const [typeCard, setTypeCard] = useState('naturalForm');

  const isMobile = useMobileBreakpoint();

  const styleClass = isMobile ? 'mobile' : 'tabs';

  // const callback = (key) => {
  //   setTypeCard(key);
  // }; onChange={()=>callback}

  return (
    <TriptychLayout className="initPage" noPrependPadding noAppendPadding>
      <div className="init__background" />
      <div>
        <p className="initPage__title">VanTrust Capital.</p>
        <div className={`initPage__${styleClass}`}>
          <Tabs defaultActiveKey="1" type="card" centered destroyInactiveTabPane>
            <TabPane tab="Persona Natural" key="1">
              <NaturalForm />
            </TabPane>
            <TabPane tab="Persona Jurídica" key="2">
              <InitialLegalForm />
            </TabPane>
          </Tabs>
        </div>
      </div>
      {/* {typeCard === 'naturalForm2' ? <RequirementsNatural /> : <RequirementsLegal />} */}
    </TriptychLayout>
  );
};

export default InitPage;
